import { render, staticRenderFns } from "./TenderBidders.vue?vue&type=template&id=aa4157ea"
import script from "./TenderBidders.vue?vue&type=script&lang=js"
export * from "./TenderBidders.vue?vue&type=script&lang=js"
import style0 from "./TenderBidders.vue?vue&type=style&index=0&id=aa4157ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports